import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IAuthLoaderState } from './auth-loaders.interfaces'

const initialState: IAuthLoaderState = {
  isSigningIn: false,
  isSigningUp: false,
  isSigningOut: false,
  isRecoveringPassword: false,
  isSendingEmail: false,
  isResetPassword: false,
  isVerifyingMfa: false
}

const authLoaderSlice = createSlice({
  name: 'authLoader',
  initialState,
  reducers: {
    setIsSigningIn: (state, action: PayloadAction<boolean>) => {
      state.isSigningIn = action.payload
    },
    setIsSigningUp: (state, action: PayloadAction<boolean>) => {
      state.isSigningUp = action.payload
    },
    setIsSigningOut: (state, action: PayloadAction<boolean>) => {
      state.isSigningOut = action.payload
    },
    setIsRecoveringPassword: (state, action: PayloadAction<boolean>) => {
      state.isRecoveringPassword = action.payload
    },
    setIsSendingEmail: (state, action: PayloadAction<boolean>) => {
      state.isSendingEmail = action.payload
    },
    setIsResetPassword: (state, action: PayloadAction<boolean>) => {
      state.isResetPassword = action.payload
    },
    setIsVerifyingMfa: (state, action: PayloadAction<boolean>) => {
      state.isVerifyingMfa = action.payload
    }
  }
})

export const {
  setIsSigningIn,
  setIsSigningUp,
  setIsSigningOut,
  setIsRecoveringPassword,
  setIsSendingEmail,
  setIsResetPassword,
  setIsVerifyingMfa
} = authLoaderSlice.actions

export default authLoaderSlice.reducer
